import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initTrainingsShow');
    $('tr.many-participants').addClass('collapse');
    $('.toggle-many-participants').on('click', function () {
      $('tr.many-participants').toggleClass('collapse');
    });
    $('tr.many-waiters').addClass('collapse');
    $('.toggle-many-waiters').on('click', function () {
      $('tr.many-waiters').toggleClass('collapse');
    });
    $('#modalMail').on('shown.bs.modal', function () {
      $('#emails').select();
    });

    //var bestPictures = new Bloodhound({
    //  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('full_name'),
    //  queryTokenizer: Bloodhound.tokenizers.whitespace,
    //  remote: {
    //    url: '/users/search.json?utf8=✓&q%5Bfull_name_or_email_cont%5D=%QUERY',
    //    wildcard: '%QUERY'
    //  }
    //});
    //
    //$('#remote .typeahead').typeahead({
    //  hint: true,
    //  highlight: true,
    //}, {
    //  name: 'items',
    //  display: 'full_name',
    //  source: bestPictures,
    //  //limit : 1000,
    //  templates: {
    //    empty: '<p class="tt-empty"><i>nincs találat</i></p>',
    //    suggestion: function (data) {
    //      return '<p>' + data.full_name + ' <small>(' + data.email + ')</small></p>';
    //    }
    //  }
    //}).bind('typeahead:select', function (ev, suggestion) {
    //  $('#training_participation_user_id').val(suggestion.id);
    //  console.log(suggestion);
    //}).bind('typeahead:autocompleted', function (ev, suggestion) {
    //  $('#training_participation_user_id').val(suggestion.id);
    //  console.log(suggestion);
    //});
  }
}